const $ = require('jquery');

$(window).on('load', function() {
  if($('#contact-map').length) {
    initContactMap();
  }
});

function initContactMap() {
  const INTIAL_CENTER = {lat: 43.180756, lng: -70.899475};

  const map = new google.maps.Map(document.getElementById('contact-map'), {
    zoom: 14,
    center: INTIAL_CENTER,
  });

  const marker = new google.maps.Marker({
    position: INTIAL_CENTER,
    map: map,
    title: 'COAST Headquarters',
  });

  google.maps.event.addDomListener(window, 'resize', function() {
    map.setCenter(INTIAL_CENTER);
});
}
